import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, SimpleChange } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import * as _ from 'lodash';
import { TreeNode, TreeOptions, TreeData } from '../tree.interface';
import { trigger, transition, style, animate, state } from '@angular/animations';
import { TreeComponent } from '../tree.component';

@Component({
  selector: 'app-node',
  templateUrl: './node.component.html',
  styleUrls: ['./node.component.scss'],
  providers: [TreeComponent],

  animations: [
    trigger('onOff', [
      transition(':enter', [
        style({ opacity: 0, height: '0', filter: 'blur(40px)' }),
        animate('300ms cubic-bezier(.51,.38,.57,.85)', style({ opacity: 1,height: '*',filter: 'blur(0)'  }))
      ]),
      transition(':leave', [
        style({ opacity: 1, height: '*',filter: 'blur(0)'  }),
        animate('300ms cubic-bezier(.51,.38,.57,.85)', style({ opacity: 0,  height: '0',filter: 'blur(40px)' }))
      ])
    ]),
    trigger('onOff2', [
      transition(':enter', [
        style({ opacity: 0, width: '0', filter: 'blur(40px)' }),
        animate('300ms cubic-bezier(.51,.38,.57,.85)', style({ opacity: 1,width: '*',filter: 'blur(0)'  }))
      ]),
      transition(':leave', [
        style({ opacity: 1, width: '*',filter: 'blur(0)'  }),
        animate('300ms cubic-bezier(.51,.38,.57,.85)', style({ opacity: 0,  width: '0',filter: 'blur(40px)' }))
      ])
    ]),
    trigger('showNewPageButton', [
      state('false', style({  opacity: 1, }),),
      state('true', style({ opacity: 0 })),
      transition('false => true', animate('300ms cubic-bezier(.51,.38,.57,.85)')),
      transition('true => false', animate('300ms cubic-bezier(.51,.38,.57,.85)'))
    ]),
  
  ],
})

export class NodeComponent implements OnInit {
  @Input() data: TreeNode | undefined;
  @Input() expand?: boolean;
  @Input() mobile?: boolean;
  @Input() parentIcon?: string;
  @Input() expanded: boolean = false; //expanded is global
  //outputs 
  @Output() onNodeClick: EventEmitter<any> = new EventEmitter<any>();

  //field: Object;

  parsedOptions: TreeOptions | undefined;
  parsedData: TreeData | undefined;

  constructor(private router: Router, private tree: TreeComponent) {
    //this.field = { dataSource: this.data, id: 'id', text: 'name', child: 'children' };
    router.events.forEach((event) => {
      if (event instanceof NavigationStart) {
        this.nodeOperation(event.url);
      }

    });
  }

  ngOnInit(): void {
    this.nodeOperation(this.router.url);
  }

  expandNode(name: string) {

    this.data!.expand = !this.data!.expand
    this.expand = this.data?.expand;
    if (this.data!.iconClass == 'icon-chevron-down') {
      this.data!.iconClass = 'icon-chevron-up'
    } else {
      this.data!.iconClass = 'icon-chevron-down';
    }
  }

  onNodeSelect(event: any) {
    //console.log(event.nodeData);
    //let data:any = this.tree!.getTreeData(event.node.id);    
    //let seriusData:any = this.tree!.getTreeData().find(x => x['id'] == event.nodeData.id || x['text'] == event.nodeData.text);  
    //console.log(seriusData[0]['route']);
    this.router.navigate([event]);
    this.onNodeClick.emit(event);
  }

  keyDwn(event: any, route: string) {
    if(event.key == 'Enter') {
      this.router.navigate([route]);
    }
  }


  expandOnFocus(event: any, route: string) {
    if(event.key == 'Enter') {
      this.expandNode(route);
    }
  }

  newWindow(event: any) {
    //console.log(event.nodeData);
    //let data:any = this.tree!.getTreeData(event.node.id);    
    //let seriusData:any = this.tree!.getTreeData().find(x => x['id'] == event.nodeData.id || x['text'] == event.nodeData.text);  
    //console.log(seriusData[0]['route']);
    // this.router.navigate([event]); 
    window.open(event, '_blank')
    //this.onNodeClick.emit(event);
  }

  nodeOperation(url: string) {

    let route = '/' + this.data!.route;

    this.data!.cssClass = ''


    if (url.includes(route)) {
      this.data!.expand = true;
      this.data!.cssClass = 'node-selected'
    }

    this.data!.children.forEach(nodeCh => {
      // let routeCh = '/'+nodeCh.route;
      // nodeCh.expand = false;
      // nodeCh.cssClass = ''
      // let routeSplit = routeCh.split('/');
      // let lastOne = '';
      // routeSplit.forEach(rs=>{
      //   lastOne = rs;
      // })
      //   if(url.includes(routeCh) || url.includes(lastOne)){

      //   nodeCh.cssClass = 'node-selected'
      //   node.expand = true;
      // }
      this.nodeRepeat(nodeCh, url)

    })

    if (this.data!.expand) {
      this.data!.iconClass = 'icon-chevron-up'
    } else {
      this.data!.iconClass = 'icon-chevron-down'
    }

  }


  nodeRepeat(nodeCh: TreeNode, url: string) {

    let routeCh = '/' + nodeCh.route;
    nodeCh.expand = false;
    nodeCh.cssClass = ''
    let routeSplit = routeCh.split('/');
    let lastOne = '';
    routeSplit.forEach(rs => {
      lastOne = rs;
    })
    if (url.includes(routeCh) || url.includes(lastOne)) {

      nodeCh.cssClass = 'node-selected'

      this.data!.expand = true;


    }

    if (nodeCh.children.length > 0) {
      nodeCh.children.forEach(nodeChCh => {
        this.nodeRepeat(nodeChCh, url)
      })
    }


  }

}
